import React from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import Button from "../../../../../../components/button/button.jsx"
import InputForm from "../../../../../../components/input/input-form.jsx";
import Attach from "../../../../../../components/attach/attach.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";

const initialAttach = {
    id: "",
    description: "",
    file: "",
    attachId: ""
}

const Attachs = ({attachList, setAttachList}) => {

    const add = () => {
        initialAttach.id = Date.now()
        setAttachList(prev => ([...prev, initialAttach]))
    }

    const onChange = async (index, field, value) => {
        setAttachList(prev => {
            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                [field]: value
            }

            return updated;
        });
    }

    const onChangeFile = (file, index, field) => {
        if (file) {
            setAttachList(prev => {
                const updated = [...prev];

                updated[index] = {
                    ...updated[index],
                    [field]: file
                }

                return updated;
            });
        }
    }

    const removeFile = (index) => {
        setAttachList(prev => {
            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                file: "",
                attachId: ""
            }

            return updated;
        });
    }

    const remove = (index) => {
        setAttachList(prev => prev.filter((_, i) => i !== index));
    }

    return (
        <Card className={"mt-2"}>
            <Card.Header>
                <Card.Title>Anexos</Card.Title>
            </Card.Header>
            <Card.Body>
                {
                    attachList.map((m, index) => {
                        return (
                            <div className="grid grid-cols-12 gap-4 mb-3 p-4 border border-[#ddd] rounded relative" key={index}>
                                <div className="col-span-2">
                                    <Attach
                                        onChangeFile={(file) => onChangeFile(file, index, "file")}
                                        removeFile={() => removeFile(index)}
                                        itemId={`file-${index}`}
                                        attachId={m.file || m.attachId}/>
                                </div>

                                <div className="col-span-10">
                                    <InputForm
                                        id={`description-${index}`}
                                        value={m.description || ""}
                                        label="Descrição"
                                        name={"description"}
                                        onChange={(e) => onChange(index, "description", e.target.value)}/>
                                </div>

                                <Button className={"w-[25px] !h-[25px] !p-0 absolute -top-2 -right-2"} target={"danger"} onClick={() => remove(index)}>
                                    <FaTrash />
                                </Button>
                            </div>
                        )
                    })
                }
                <Button onClick={add}>
                    <FaPlus />Adicionar anexo
                </Button>
            </Card.Body>
        </Card>
    );
};

export default Attachs;